document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-load-more]');
  if (!link) return;
  event.preventDefault();

  const sectionId = link.dataset.sectionId;
  const url = new URL(link.href);
  url.searchParams.set('section_id', sectionId);

  link.textContent = link.textContent;
  link.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(url.toString());
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newCards = doc.querySelector('[data-product-grid]');
    const currentGrid = document.querySelector('[data-product-grid]');
    if (newCards && currentGrid) {
      const addedCount = newCards.children.length;
      currentGrid.append(...newCards.children);

      const progress = document.querySelector('[data-collection-progress]');
      if (progress) {
        const total = Number(progress.dataset.total);
        const shown = Math.min(Number(progress.dataset.shown) + addedCount, total);
        progress.dataset.shown = shown;
        progress.querySelector('.collection-progress__fill').style.width = `${(shown / total) * 100}%`;
        const countEl = progress.querySelector('[data-viewed-count]');
        if (countEl) countEl.textContent = shown.toLocaleString();
      }
    }

    const newLoadMore = doc.querySelector('[data-load-more]');
    if (newLoadMore) {
      link.href = newLoadMore.href;
      link.removeAttribute('aria-busy');
    } else {
      link.remove();
    }
  } catch (error) {
    window.location.href = link.href;
  }
});
